import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTrustpilotStarGrey = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 46,
	height: 44,
	viewBox: "0 0 46 44",
	fill: "#E7E9F1",
	stroke: "#E7E9F1",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M27.7627 16.4795C27.8657 16.7758 28.1424 16.977 28.4561 16.9834L43.4814 17.2891L31.5049 26.3691C31.2552 26.5586 31.1495 26.8835 31.2402 27.1836L35.5918 41.5674L23.2568 32.9844C22.9993 32.8052 22.6569 32.8052 22.3994 32.9844L10.0635 41.5674L14.416 27.1836C14.5067 26.8835 14.4011 26.5586 14.1514 26.3691L2.17383 17.2891L17.2002 16.9834C17.5138 16.977 17.7906 16.7758 17.8936 16.4795L22.8281 2.28223L27.7627 16.4795Z",
		fillOpacity: .3,
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgTrustpilotStarGrey;
